<template>
  <div id="add-new-order-modal">
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="editWarehouseModal"
        persistent
        max-width="340px"
      >
        <v-card>
          <form
            action=""
            @submit.prevent="submitForm()"
          >
            <v-card-title>
              <v-flex
                xs11
                sm11
                md11
              ><span class="headline">{{ $t('warehouse.updateWarehouseTitle') }}</span></v-flex>
              <v-flex
                xs1
                sm1
                md1
              >
                <v-btn
                  flat
                  @click="closeEditWarehouseModal()"
                  class="close"
                ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert
                :value="seccessAlert"
                type="success"
              >
                {{ $t('warehouse.warehouseUpdatedSuccessfully') }}
              </v-alert>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex
                    xs12
                    sm3
                    md3
                  >
                    <v-select
                      :items="warehouses"
                      item-value="value"
                      v-model="editWarehouseData.warehouse_id_fk"
                      :error-messages="errors.collect('Warehouse')"
                      data-vv-name="Warehouse"
                      :label="$t('columns.warehouse') + '*'"
                      v-validate="'required'"
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                id="sendButton"
                type="submit"
                style="height:auto" class="rtl-mr-20"
                outline
                color="success"
              >{{ $t('common.save') }}</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: [
    'seccessAlert',
    'editWarehouseModal',
    'closeEditWarehouseModal',
    'editWarehouseData',
    'editWarehouse',
    'warehouses'
  ],

  methods: {
    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.editWarehouse()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/editWarehouse.vue